import React, { useEffect, useState } from 'react';
import { getQueryStringArgs } from '@/utils/url-parse';
import PaginationComponent from '@/components/PaginationComponent';
import CalculateComponent from '@/components/CalculateComponent';
import NameIcon from '@/components/NameIcon';
import { Empty } from 'antd';
import { Table } from '@alifd/next';
import Requests from '@/services/request';
import $i18n from '@/i18n';
import './index.less';

const Unsorted = (props) => {
  const { channelCode } = getQueryStringArgs();
  // 内容区域高度
  const [contentHeight, setContentHeight] = useState<number>(200);

  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });
  const [tableData, setTableData] = useState({ totalCount: 0, data: [] });

  const initData = (
    params = {
      pageNum: 1,
      pageSize: 10,
      channelCode,
      categoryId: null,
    },
  ) => {
    Requests.post('/rest/intercnn/channel/category/miniapp/listNoBind', {
      ...params,
    }).then((res) => {
      if (res) {
        const { list = [], total } = res;
        setTableData({
          data: list,
          totalCount: total,
        });
      }
    });
  };

  useEffect(() => {
    initData({
      pageNum: paginationValue.currentPage,
      pageSize: paginationValue.pageSize,
      channelCode,
      categoryId: null,
    });
  }, [paginationValue]);

  const columns = [
    {
      title: 'Icon',
      dataIndex: 'iconPublicUrl',
      render: (v, i, record) =>
        v ? (
          <img style={{ width: '30px', height: '30px' }} src={v} />
        ) : (
          <NameIcon
            name={record.name}
            styles={{ width: '30px', height: '30px', fontSize: '20px' }}
            shape="square"
          />
        ),
    },
    {
      title: $i18n.get({ id: 'aopf.component.unsorted.ApplicationName', dm: '应用名称' }),
      dataIndex: 'name',
      render: (v) => <span>{v}</span>,
    },
    {
      title: $i18n.get({ id: 'aopf.component.unsorted.OnlineVersion', dm: '在线版本' }),
      dataIndex: 'onlineVersion',
      render: (v, i, record) => <div>{record.publishStatus === 'ONLINE' ? v : '-'}</div>,
    },
  ];

  /**
   * 翻页查询处理
   * @param current 当前页码
   * @param pageSize 每页数据量
   */
  const pageChangeHandler = (current: number, pageSize: number) => {
    setPaginationValue({
      currentPage: current,
      pageSize,
    });
  };

  return (
    <div className="unsorted-list">
      {tableData.data.length > 0 ? (
        <>
          <Table dataSource={tableData.data}>
            {columns.map((i) => (
              <Table.Column
                title={i.title}
                dataIndex={i.dataIndex}
                cell={(v, index, record) => i.render(v, index, record)}
              />
            ))}
          </Table>
          <CalculateComponent
            otherWidth={280}
            otherHeight={88 + 48 + 24 + 56 + 56}
            windowChange={(_width, height) => {
              setContentHeight(height);
            }}
          />

          <div className="list-pagination">
            <PaginationComponent
              total={tableData.totalCount}
              current={paginationValue.currentPage}
              pageSize={paginationValue.pageSize}
              onPageChange={pageChangeHandler}
            />
          </div>
        </>
      ) : (
        <Empty 
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span>
              {$i18n.get({
                id: 'aopf.pages.miniAppStore.setting.category.list.no.data',
                dm: '暂无数据',
              })}
            </span>
          }
         />
      )}
    </div>
  );
};

export default Unsorted;
